import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp } from "@fortawesome/pro-light-svg-icons";
import axiosConfig from "../../services/Axios";
import { useForm } from "react-hook-form";
import FieldError from "./FieldError";
import { useRef } from "react";
import { toast } from "react-toastify";

const FileUploadArea = ({
  submitUrl, // endpoint de la resource.
  formDataExtraValues, // valeures optionelles, tel qu'un ID de relation.
  successFn,
}) => {
  const form = useForm();
  const formSubmitBtn = useRef();
  const inputFile = useRef();
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    formSubmitBtn.current.click();
  };

  const onSubmit = async (data) => {
    let formData = {};
    formData.file = inputFile.current.files[0];

    formDataExtraValues.map((ev) => {
      Object.entries(ev).forEach(([key, value]) => {
        formData[key] = value;
      });
    });

    try {
      await axiosConfig
        .post(submitUrl, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response?.status === 201 && response?.data) {
            toast.success(t("settings.items.picture_created"), {
              theme: "colored",
              hideProgressBar: true,
            });
            successFn(response.data);
          }
        });
    } catch (e) {
      if (e.response?.status !== 200 && e.response?.data?.violations) {
        form.setError("file", {
          message: e.response.data.violations[0].message,
          type: "manual",
        });
      }
    }
  };

  return (
    <>
      <form
        onSubmit={form.handleSubmit((data) => onSubmit(data))}
        encType="multipart/form-data"
      >
        <div className="flex justify-center items-center w-full">
          <label
            htmlFor="dropzone-file"
            className={`flex flex-col justify-center items-center w-full h-32 rounded-lg border ${
              form.formState?.errors?.file
                ? "text-red-600 border-red-500 bg-red-50 hover:bg-red-100"
                : "bg-gray-50 border-gray-300 hover:bg-gray-100"
            } cursor-pointer`}
          >
            <div className="flex flex-col justify-center items-center pt-5 pb-6">
              <FontAwesomeIcon
                icon={faCloudArrowUp}
                className="text-4xl mb-2"
              />
              <p className="mb-2 text-sm">
                <span className="font-bold">{t("global.clickToAddFile")}</span>
              </p>
              <p className="text-xs font-light">
                {t("global.fileUploadFormat")}
              </p>
            </div>
            <input
              type="file"
              id="dropzone-file"
              className="hidden"
              {...form.register("file")}
              onChange={(event) => handleSubmit(event)}
              ref={inputFile}
            />

            <input type="submit" className="hidden" ref={formSubmitBtn} />
          </label>
        </div>
        <FieldError error={form.formState?.errors?.file} />
      </form>
    </>
  );
};

export default FileUploadArea;
